import { useCallback, useState, useRef } from 'react';
import { HubConnectionBuilder } from '@microsoft/signalr';
import chargerActions from '../store/actions/chargerActions'
import { useDispatch } from 'react-redux';



function useSignalR({ ...props }) {

    const [openPopupModal, setOpenPopupModal] = useState(false);
    const [, setSummaryData] = useState([]);
    const dispatch = useDispatch()
    const { cookies } = props;
    const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || 'https://localhost:5011').replace(/\/$/, '');
    const signalRHubUrl = process.env.REACT_APP_SIGNALR_HUB_URL || `${apiBaseUrl}/hubs/SignalRMobileClient`;

    // Use ref to store the token to avoid recreating setupSignalRConnection when cookies change
    const tokenRef = useRef(null);
    const ourCookies = cookies.get('isLoggedIn');
    tokenRef.current = ourCookies?.token;

    const setupSignalRConnection = useCallback(() => {
        const hubUrl = signalRHubUrl;
        const newConnection = new HubConnectionBuilder()
            .withUrl(hubUrl, { accessTokenFactory: () => tokenRef.current })
            .withAutomaticReconnect()
            .configureLogging('info')
            .build();

        return newConnection;
    }, [signalRHubUrl]);

    const handleReceiveMessage = useCallback((eventName, message) => {
        // Call the corresponding event handler based on the event name
        switch (eventName) {
            case 'UpdateConnectorStatus':
                dispatch(chargerActions.updateConnectorStatus(message));
                break;
            case 'UpdateChargerStatus':
                dispatch(chargerActions.updateChargerStatus(message));
                break;
            case 'UpdateChargingSummery':
                setSummaryData([message]);
                dispatch(chargerActions.updateChargingSummery([message]));
                dispatch(chargerActions.clearTransactionData());
                break;
            case 'UpdateTransactionData':
                dispatch(chargerActions.updateTransactionData(message));
                break;
            case 'ChargePointDetails':
                dispatch(chargerActions.chargePointDetails(message));
                break;
            default:
                break;
        }
    }, [dispatch]);

    const handlePopupModal = useCallback(() => {
        setOpenPopupModal(true);
    }, []);

    return { openPopupModal, setOpenPopupModal, setupSignalRConnection, handleReceiveMessage, handlePopupModal };
    // return { openPopupModal, setOpenPopupModal, summaryData, setupSignalRConnection, handleReceiveMessage, handlePopupModal };
}


export default useSignalR;